import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-project-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {
    
  }

  get(): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/project/get", this.httpOptions);
  }

  getById(id: any): Observable<any> {
      return this.http.get<any>(this.configService.config.projectUrl + "/api/project/get/" + id, this.httpOptions);
  }

  getByIds(ids: any[]): Observable<any> {
    
    var sIds = JSON.stringify(ids);
    let requestOptions = {
      params: new HttpParams()
        .append('projectIds', ids !== null && ids !== undefined ? ids.join(', ') : ""),
      headers: this.httpOptions.headers,
    }
    return this.http.get<any>(this.configService.config.projectUrl + "/api/project/getByIds", requestOptions);
  }

  //Eirik 11.08.20 v2.0.31.3 task 318 - need to send the projectids as a parameter which is picked up in a class in the api. This way we can send vast amounts of projectids to the server
  getByIdsVM(ids: any[]): Observable<any> {
    
    let vm = {
      SearchText: "",
      ProjectIds: ids,
    }
    return this.http.post<any>(this.configService.config.projectUrl + "/api/project/getByIds", vm, this.httpOptions);
  }

  getByCustomerId(customerId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + '/api/project/GetByCustomerId?customerId=' + customerId, this.httpOptions);
  }

  getBySearchText(searchText): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + '/api/project/getbysearchtext?searchtext=' + searchText, this.httpOptions);
  }

  getBySearchTextAndProjectIds(searchText: string, projectIds: any[]): Observable<any> {
    let requestOptions = {
      params: new HttpParams()
        .append('searchtext', searchText)
        .append('projectIds', projectIds !== null && projectIds !== undefined ? projectIds.join(', ') : ""),
      headers: this.httpOptions.headers,
    }
    return this.http.get<any>(this.configService.config.projectUrl + '/api/project/GetBySearchTextAndProjectIds', requestOptions);
  }

  //Eirik 11.08.20 v2.0.31.3 task 318 - need to send the projectids as a parameter which is picked up in a class in the api. This way we can send vast amounts of projectids to the server
  getBySearchTextAndProjectIdsVM(searchText: string, projectIds: any[]): Observable<any> {
    
    let vm = {
      SearchText: searchText,
      ProjectIds: projectIds,
    }

    return this.http.post<any>(this.configService.config.projectUrl + '/api/project/GetBySearchTextAndProjectIds', vm, this.httpOptions);
  }

  getWithChildrenById_FromMotherProject(id: any, selectedProjectRoleIds: any[]): Observable<any> {
    
    let projectRoleIds = "";
    selectedProjectRoleIds.forEach(projectRoleId => {

      projectRoleIds += "projectRoleIds=" + projectRoleId;
      if (projectRoleId != selectedProjectRoleIds[selectedProjectRoleIds.length - 1]) {
        projectRoleIds += "&";
      }
    });
    
    return this.http.get<any>(this.configService.config.projectUrl + `/api/project/GetWithChildren_FromMotherProject?id=${id}&${projectRoleIds}`, this.httpOptions);
  }

  getWithChildrenById(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/project/GetWithChildren/" + id, this.httpOptions);
  }

  getBySearch(rec: any): Observable<any> {    
    return this.http.post<any>(this.configService.config.projectUrl + "/api/project/GetBySearch", rec, this.httpOptions);
  }

  getWeekApproval(viewModel: any): Observable<any> {
    
    return this.http.post<any>(this.configService.config.projectUrl + "/api/project/GetVMWeekApproval", viewModel, this.httpOptions);
  }

  addWeekApproval(values: any): Observable<any> {
    
    var weekApproval = {
      EmployeeId: values.EmployeeId,
      SelectedDate: values.SelectedDate,
      ProjectId: values.ProjectId,
      TimeTypeId: values.TimeTypeId,
      CategoryId: values.CategoryId,
      StatusId: values.StatusId,

      MondayTimeId: values.MondayTimeId,
      MondaySeconds: values.MondaySeconds,

      TuesdayTimeId: values.TuesdayTimeId,
      TuesdaySeconds: values.TuesdaySeconds,

      WednesdayTimeId: values.WednesdayTimeId,
      WednesdaySeconds: values.WednesdaySeconds,

      ThursdayTimeId: values.ThursdayTimeId,
      ThursdaySeconds: values.ThursdaySeconds,

      FridayTimeId: values.FridayTimeId,
      FridaySeconds: values.FridaySeconds,

      SaturdayTimeId: values.SaturdayTimeId,
      SaturdaySeconds: values.SaturdaySeconds,

      SundayTimeId: values.SundayTimeId,
      SundaySeconds: values.SundaySeconds,
    }

    return this.http.post<any>(this.configService.config.projectUrl + '/api/project/AddWeekApproval', weekApproval, this.httpOptions);
  }

  updateWeekApproval(values: any): Observable<any> {
    
    var weekApproval = {
      EmployeeId: values.EmployeeId,
      SelectedDate: values.SelectedDate,
      ProjectId: values.ProjectId,
      TimeTypeId: values.TimeTypeId,
      CategoryId: values.CategoryId,
      StatusId: values.StatusId,

      MondayTimeId: values.MondayTimeId,
      MondaySeconds: values.MondaySeconds,

      TuesdayTimeId: values.TuesdayTimeId,
      TuesdaySeconds: values.TuesdaySeconds,

      WednesdayTimeId: values.WednesdayTimeId,
      WednesdaySeconds: values.WednesdaySeconds,

      ThursdayTimeId: values.ThursdayTimeId,
      ThursdaySeconds: values.ThursdaySeconds,

      FridayTimeId: values.FridayTimeId,
      FridaySeconds: values.FridaySeconds,

      SaturdayTimeId: values.SaturdayTimeId,
      SaturdaySeconds: values.SaturdaySeconds,

      SundayTimeId: values.SundayTimeId,
      SundaySeconds: values.SundaySeconds,
    }

    return this.http.put<any>(this.configService.config.projectUrl + '/api/project/UpdateWeekApproval', weekApproval, this.httpOptions);
  }

  confirmWeekApproval(selectedWeekApprovalKeys: any): Observable<any> {
    
    var weekApprovalsToConfirm = [];
    for (let i = 0; i < selectedWeekApprovalKeys.length; i++) {
      var weekApproval = {
        EmployeeId: selectedWeekApprovalKeys[i].EmployeeId,
        SelectedDate: selectedWeekApprovalKeys[i].SelectedDate,
        ProjectId: selectedWeekApprovalKeys[i].ProjectId,
        TimeTypeId: selectedWeekApprovalKeys[i].TimeTypeId,
        CategoryId: selectedWeekApprovalKeys[i].CategoryId,

        MondayTimeId: selectedWeekApprovalKeys[i].MondayTimeId,
        MondaySeconds: selectedWeekApprovalKeys[i].MondaySeconds,

        TuesdayTimeId: selectedWeekApprovalKeys[i].TuesdayTimeId,
        TuesdaySeconds: selectedWeekApprovalKeys[i].TuesdaySeconds,

        WednesdayTimeId: selectedWeekApprovalKeys[i].WednesdayTimeId,
        WednesdaySeconds: selectedWeekApprovalKeys[i].WednesdaySeconds,

        ThursdayTimeId: selectedWeekApprovalKeys[i].ThursdayTimeId,
        ThursdaySeconds: selectedWeekApprovalKeys[i].ThursdaySeconds,

        FridayTimeId: selectedWeekApprovalKeys[i].FridayTimeId,
        FridaySeconds: selectedWeekApprovalKeys[i].FridaySeconds,

        SaturdayTimeId: selectedWeekApprovalKeys[i].SaturdayTimeId,
        SaturdaySeconds: selectedWeekApprovalKeys[i].SaturdaySeconds,

        SundayTimeId: selectedWeekApprovalKeys[i].SundayTimeId,
        SundaySeconds: selectedWeekApprovalKeys[i].SundaySeconds,
      }
      weekApprovalsToConfirm.push(weekApproval);
    }
    return this.http.put<any>(this.configService.config.projectUrl + '/api/project/ConfirmWeekApproval', JSON.stringify(weekApprovalsToConfirm), this.httpOptions);
  }

  approveWeekApproval(selectedWeekApprovalKeys: any): Observable<any> {
    
    var weekApprovalsToApprove = [];
    for (let i = 0; i < selectedWeekApprovalKeys.length; i++) {
      var weekApproval = {
        EmployeeId: selectedWeekApprovalKeys[i].EmployeeId,
        SelectedDate: selectedWeekApprovalKeys[i].SelectedDate,
        ProjectId: selectedWeekApprovalKeys[i].ProjectId,
        TimeTypeId: selectedWeekApprovalKeys[i].TimeTypeId,
        CategoryId: selectedWeekApprovalKeys[i].CategoryId,
        StatusId: selectedWeekApprovalKeys[i].StatusId,

        MondayTimeId: selectedWeekApprovalKeys[i].MondayTimeId,
        MondaySeconds: selectedWeekApprovalKeys[i].MondaySeconds,

        TuesdayTimeId: selectedWeekApprovalKeys[i].TuesdayTimeId,
        TuesdaySeconds: selectedWeekApprovalKeys[i].TuesdaySeconds,

        WednesdayTimeId: selectedWeekApprovalKeys[i].WednesdayTimeId,
        WednesdaySeconds: selectedWeekApprovalKeys[i].WednesdaySeconds,

        ThursdayTimeId: selectedWeekApprovalKeys[i].ThursdayTimeId,
        ThursdaySeconds: selectedWeekApprovalKeys[i].ThursdaySeconds,

        FridayTimeId: selectedWeekApprovalKeys[i].FridayTimeId,
        FridaySeconds: selectedWeekApprovalKeys[i].FridaySeconds,

        SaturdayTimeId: selectedWeekApprovalKeys[i].SaturdayTimeId,
        SaturdaySeconds: selectedWeekApprovalKeys[i].SaturdaySeconds,

        SundayTimeId: selectedWeekApprovalKeys[i].SundayTimeId,
        SundaySeconds: selectedWeekApprovalKeys[i].SundaySeconds,
      }
      weekApprovalsToApprove.push(weekApproval);
    }
    return this.http.put<any>(this.configService.config.projectUrl + '/api/project/ApproveWeekApproval', JSON.stringify(weekApprovalsToApprove), this.httpOptions);
  }

  resetWeekApproval(selectedWeekApprovalKeys: any, statusId: number): Observable<any> {
    
    var weekApprovalsToReset = [];
    for (let i = 0; i < selectedWeekApprovalKeys.length; i++) {
      var weekApproval = {
        EmployeeId: selectedWeekApprovalKeys[i].EmployeeId,
        SelectedDate: selectedWeekApprovalKeys[i].SelectedDate,
        ProjectId: selectedWeekApprovalKeys[i].ProjectId,
        TimeTypeId: selectedWeekApprovalKeys[i].TimeTypeId,
        CategoryId: selectedWeekApprovalKeys[i].CategoryId,
        StatusId: selectedWeekApprovalKeys[i].StatusId,

        MondayTimeId: selectedWeekApprovalKeys[i].MondayTimeId,
        MondaySeconds: selectedWeekApprovalKeys[i].MondaySeconds,

        TuesdayTimeId: selectedWeekApprovalKeys[i].TuesdayTimeId,
        TuesdaySeconds: selectedWeekApprovalKeys[i].TuesdaySeconds,

        WednesdayTimeId: selectedWeekApprovalKeys[i].WednesdayTimeId,
        WednesdaySeconds: selectedWeekApprovalKeys[i].WednesdaySeconds,

        ThursdayTimeId: selectedWeekApprovalKeys[i].ThursdayTimeId,
        ThursdaySeconds: selectedWeekApprovalKeys[i].ThursdaySeconds,

        FridayTimeId: selectedWeekApprovalKeys[i].FridayTimeId,
        FridaySeconds: selectedWeekApprovalKeys[i].FridaySeconds,

        SaturdayTimeId: selectedWeekApprovalKeys[i].SaturdayTimeId,
        SaturdaySeconds: selectedWeekApprovalKeys[i].SaturdaySeconds,

        SundayTimeId: selectedWeekApprovalKeys[i].SundayTimeId,
        SundaySeconds: selectedWeekApprovalKeys[i].SundaySeconds,
      }
      weekApprovalsToReset.push(weekApproval);
    }
    return this.http.put<any>(this.configService.config.projectUrl + `/api/project/ResetWeekApproval?statusId=${statusId}`, JSON.stringify(weekApprovalsToReset), this.httpOptions);
  }

  //grab timeids from weekapproval and send them to server to be deleted
  deleteWeekApproval(weekApproval: any): Observable<any> {
    
    let timeIds = [];
    timeIds.push(weekApproval.MondayTimeId);
    timeIds.push(weekApproval.TuesdayTimeId);
    timeIds.push(weekApproval.WednesdayTimeId);
    timeIds.push(weekApproval.ThursdayTimeId);
    timeIds.push(weekApproval.FridayTimeId);
    timeIds.push(weekApproval.SaturdayTimeId);
    timeIds.push(weekApproval.SundayTimeId);

    let requestOptions = {
      params: new HttpParams()
        .append('timeIds', timeIds.join(', ')),
      headers: this.httpOptions.headers,
    }
    return this.http.delete<any>(this.configService.config.projectUrl + '/api/project/DeleteWeekApproval', requestOptions);
  }

  getCustomers(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.projectUrl + "/api/customer/Get", this.httpOptions);
  }

  getCustomer(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/customer/Get/" + id, this.httpOptions);
  }

  getProjectStatuses(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.projectUrl + "/api/projectstatus/Get", this.httpOptions);
  }

  getProjectRoles(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.projectUrl + "/api/projectrole/Get", this.httpOptions);
  }

  getMyProjectRoles(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.projectUrl + "/api/projectrole/MyProjectRoles", this.httpOptions);
  }

  getProjectRolesShouldDisable(moduleFunctionId: any): Observable<any> {

    return this.http.get<any>(this.configService.config.projectUrl + "/api/projectrole/ShouldDisable?moduleFunctionId=" + moduleFunctionId, this.httpOptions);
  }

  getProjectTypes(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.projectUrl + "/api/projecttype/Get", this.httpOptions);
  }

  getProjectType(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/projecttype/Get/" + id, this.httpOptions);
  }

  getTimeTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/time/GetTimeTypes", this.httpOptions);
  }

  getEmployees(): Observable<any> {
      return this.http.get<any>(this.configService.config.projectUrl + "/api/employee/get", this.httpOptions);
  }

  getEmployeeById(id: any): Observable<any> {
      return this.http.get<any>(this.configService.config.projectUrl + "/api/employee/get/" + id, this.httpOptions);
  }

  getEmployeesBySearchText(searchText): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + '/api/employee/getbysearchtext?searchtext=' + searchText, this.httpOptions);
  }

  put(rec: any): Observable<any> {
    return this.http.put<any>(this.configService.config.projectUrl + "/api/project/put", rec, this.httpOptions);
  }

  post(rec: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + "/api/project/post", rec, this.httpOptions);
  }

  delete(id: any): Observable<any> {
    return this.http.delete<any>(this.configService.config.projectUrl + "/api/project/delete/" + id, this.httpOptions);
  }

  getActiveProjectActivites(): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + `/api/project/GetActiveProjectActivities?companyId=${this.userService.companyId}`, this.httpOptions);
  }

  getTimesCategoryStatusPairs(viewModel: any): Observable<any> {
    viewModel.CompanyId = this.userService.companyId;
    return this.http.post<any>(this.configService.config.projectUrl + `/api/project/GetProjectPortalTimesByEmployeeListCategoryStatusPair`, viewModel, this.httpOptions);
  }

  /* Addition */
  getAdditionVM(moduleFunctionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + '/api/addition/GetVMAdditionGrid?moduleFunctionId=' + moduleFunctionId, this.httpOptions);
  }

  getAdditionRecords(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + `/api/addition/GetAdditionRecords`, viewModel, this.httpOptions);
  }

  getAdditionTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/addition/GetAdditionTypes", this.httpOptions);
  }

  insertAddition(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/addition/AddAddition', addition, this.httpOptions);
  }

  updateAddition(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/addition/UpdateAddition', addition, this.httpOptions);
  }

  deleteAddition(additionId: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/addition/DeleteAddition?additionId=' + additionId, [], this.httpOptions);
  }

  deleteAdditionByAdditionIds(ids: number[]): Observable<any> {

    let additionIds = "";
    ids.forEach(additionId => {

      additionIds += "additionIds=" + additionId;
      if (additionId != ids[ids.length - 1]) {
        additionIds += "&";
      }
    });


    return this.http.post<any>(this.configService.config.projectUrl + `/api/addition/DeleteByAdditionIds?${additionIds}`, [], this.httpOptions);
  }

  /* Expense */
  getExpenseVM(moduleFunctionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + '/api/expense/GetVMExpenseGrid?moduleFunctionId=' + moduleFunctionId, this.httpOptions);
  }

  getExpenseRecords(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + `/api/expense/GetExpenseRecords`, viewModel, this.httpOptions);
  }

  getExpenseTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.projectUrl + "/api/expense/GetExpenseTypes", this.httpOptions);
  }

  insertExpense(expense: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/expense/AddExpense', expense, this.httpOptions);
  }

  updateExpense(expense: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/expense/UpdateExpense', expense, this.httpOptions);
  }

  deleteExpense(expenseId: any): Observable<any> {
    return this.http.post<any>(this.configService.config.projectUrl + '/api/expense/DeleteExpense?expenseId=' + expenseId, [], this.httpOptions);
  }

  deleteExpenseByExpenseIds(ids: number[]): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });
    
    return this.http.post<any>(this.configService.config.projectUrl + `/api/expense/DeleteByExpenseIds?${expenseIds}`, [], this.httpOptions);
  }

  confirmExpenseByExpenseIds(ids: number[]): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });
    
    return this.http.post<any>(this.configService.config.projectUrl + `/api/expense/ConfirmByExpenseIds?${expenseIds}`, [], this.httpOptions);
  }

}
